module.exports = __webpack_public_path__ + "img/wiggle.51689928.png";